'use strict';
const ContentActionWorkRepository = require('balus/infra/repository/actionwork/content');

class Service {
    /**
     * Work の Content を更新するためのサービス
     *
     * @param {Project} project
     * @param {Action}  action
     * @param {Content} content
     * @param {object}  contentJSON
     * @param {string}  contentJSON.name
     * @param {string}  contentJSON.uri
     * @param {string}  contentJSON.storageObjectId
     * @param {string}  contentJSON.thumbnailURI
     */
    constructor(project, action, content, contentJSON, relation) {
        this._project = project;
        this._action = action;
        this._content = content;
        this._contentJSON = contentJSON;
        this._relation = relation;
    }

    update() {
        //TODO: API を変更して ActionWork を渡すようにする
        return ContentActionWorkRepository.find(this._project)
            .save(this._action, this._content, this._contentJSON, this._relation);
    }
}

module.exports = Service;



// WEBPACK FOOTER //
// ./balus/app/service/actionwork/content/update.js